import Carrocel from "./Carrocel"

const StandUp = (props) => {
  const guposCategoria = [
    {grupo: 'Comendia', categorias: ["[]"]}
  ]

  return(
    <div className="items-center w-screen text-xl py-8 justify-between md:text-base gap-8">
      <div className='flex justify-center pb-10'>{props.eventosFiltrado.length} Rolês encontrados.</div>
      {guposCategoria.map(item => {
        const roles = props.eventosFiltrado.filter(elememento => item.categorias.some(categoria => elememento.subcategoria.includes(categoria)))
        if(roles.length > 0)return(
          <div className='mb-16'>
            <div className='ml-14 mb-4 text-2xl font-semibold max-w-[72vw]'>{item.grupo}</div>
            <Carrocel key={item.grupo} roles={roles} locais={props.locais} selectData={props.selectData} selectValor={props.selectValor} />
          </div>
        ) 
      })}          
    </div>
  )
}

export default StandUp